import React, { useEffect, useState } from "react";
import "./Pages.css";
import { Tooltip, Pagination } from "@mui/material";
import { getScheduledPodcasts, deletePodcast } from "../Services/SchedulesApi";
import Loader from "../Components/Loader";
import WarningDialog from "../Components/WarningDialog";
import { getUserProfileDetails } from "../Services/ShowsApi";
import { useLoader } from "../Components/LoaderContext";
import DeleteIcon from "@mui/icons-material/Delete";
import { commonConstants } from "../utils/constant";
import { useNavigate } from "react-router-dom";
import { capitalizeNames } from "../utils/nameUtils";
import PodcastCard from "../Components/PodcastCard";

const MissedSchedules = () => {
  const navigate = useNavigate();
  const [podcasts, setPodcasts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedScheduleId, setSelectedScheduleId] = useState(null);
  const [selectedPodcast, setSelectedPodcast] = useState(null); // State to hold the selected podcast
  const [userProfile, setUserProfile] = useState({
    firstName: "",
    lastName: "",
  });
  const { triggerLoader, hideLoader } = useLoader();
  const [page, setPage] = useState(1);
  const [limit] = useState(10); // assuming it's constant
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 3000); // Simulate loading for 3 seconds
  }, []);

  // Fetch the podcasts data and update the state
  useEffect(() => {
    const fetchPodcasts = async () => {
      try {
        // Fetch podcast details
        // triggerLoader("Loading missed podcasts...");
        const response = await getScheduledPodcasts("missed", page, limit); // API call to fetch podcasts
        setPodcasts(response?.data?.Data || []); // Update podcasts data
        setTotalCount(response?.data?.totalCount || 0);
        // Fetch user profile details
        const profileResponse = await getUserProfileDetails("UserID");
        const profileData = profileResponse?.data?.body?.Data?.[0] || {};
        setUserProfile({
          firstName: profileData.FirstName || "",
          lastName: profileData.LastName || "",
        });
        localStorage.setItem(
          "fullName",
          capitalizeNames(profileData.FirstName, profileData.LastName).fullName
        );
      } catch (error) {
        console.error("Error fetching podcasts:", error); // Error handling
      } finally {
        setLoading(false); // End loading after the fetch is complete
        // hideLoader();
      }
    };

    fetchPodcasts();
  }, [page]);

  const handleDelete = (scheduleId, podcast, event) => {
    event.stopPropagation();
    setSelectedScheduleId(scheduleId);
    setSelectedPodcast(podcast); // Set the selected podcast
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    setOpenDialog(false);
    triggerLoader("Deleting Podcast...");
    if (selectedScheduleId) {
      try {
        await deletePodcast(selectedScheduleId); // Call to delete the podcast
        setPodcasts(
          podcasts.filter(
            (podcast) => podcast.ScheduleID !== selectedScheduleId
          )
        );
      } catch (error) {
        console.error("Error deleting podcast:", error);
      } finally {
        hideLoader();
      }
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
    setSelectedScheduleId(null);
    setSelectedPodcast(null); // Clear the selected podcast
  };


  const handleReschedule = (podcast) => {
    navigate("/shows/create", { state: { podcast } });
  }

  return (
    <div className="theme-bg clr-white main-container-schedulemiss">
      <div className="missed-podcast-list-container" >
        {loading ? (
          <div className="show-loader-container">
            <Loader message="Fetching missed schedules" />
          </div>
        ) : (
          <div className="upcoming-podcast-container">
            {podcasts?.length === 0 ? (
              <div className="podacast-empty-container">
                <h1 className="podacast-empty">No podcasts Found</h1>
              </div>
            ) : (
              podcasts?.map((podcast, index) => (
                <PodcastCard
                  key={index}
                  podcast={podcast}
                  index={index}
                  onPrimaryAction={handleReschedule}
                  onSecondaryAction={(podcast, event) => handleDelete(podcast.ScheduleID, podcast, event)}
                  primaryButtonText="Reschedule"
                  secondaryButtonText="Remove"
                  secondaryButtonIcon={<DeleteIcon style={{ fontSize: "1.6vh", color: "#fff" }} />}
                />
              ))
            )}
          </div>
        )}
        {podcasts?.length > 0 && (
          <div style={{ display: "flex", justifyContent: "center", marginTop: "0.8vh", position: 'sticky', padding: "0.8vh", background: 'var(--theme-bg)' }}>
            <Pagination
              count={Math.ceil(totalCount / limit)}
              page={page}
              onChange={(event, value) => setPage(value)}
              sx={{
                "& .MuiPaginationItem-root": {
                  fontSize: "1.6vh",
                  minWidth: "3.2vh",
                  height: "3.2vh",
                  margin: "0 0.4vh",
                  borderRadius:"50%"
                },
                "& .MuiPaginationItem-root svg": {
                  fontSize: "2vh",
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "rgb(38 88 215)",
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "rgb(100, 100, 100)", // Hover background color
                },
              }}
            />
          </div>
        )}
      </div>
      <WarningDialog
        open={openDialog}
        onClose={handleDialogClose}
        onConfirm={confirmDelete}
        title="Delete Schedule"
        description={
          selectedPodcast?.Title
            ? `Are you sure you want to delete this schedule: ${selectedPodcast.Title}?`
            : "Are you sure you want to delete this schedule?"
        }
      />
    </div>
  );
};

export default MissedSchedules;
